import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/map/[mapSlug]/components/PanelSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/nav/TopNavbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/nav/TriggerProvider.tsx");
